import { useEffect } from 'react';
import { Link, NavLink, Outlet, useLocation } from 'react-router';
import { articlesIndex } from '../data';
import { scheduleRouteFontPrefetch } from '../dvi/warmup';
import { routeMetaFor } from '../lib/routeMeta';
import { ErrorBoundary } from './ErrorBoundary';

const NAV_ITEMS = [
  { to: '/', label: 'Home' },
  ...articlesIndex.categories.map((c) => ({ to: `/${c.key}`, label: c.nav })),
  { to: '/link', label: 'Link' },
];

export function Layout() {
  // クライアント遷移でもタブタイトルを追従させる (プリレンダリングと同じ導出)
  const location = useLocation();
  useEffect(() => {
    document.title = routeMetaFor(articlesIndex, location.pathname).title;
    // 現在ページと遷移先候補のフォントをアイドル時間に先読みする
    scheduleRouteFontPrefetch(location.pathname);
  }, [location.pathname]);
  return (
    <div className="wrapper">
      <header className="site-header">
        <nav>
          <ul>
            {NAV_ITEMS.map(({ to, label }) => (
              <li key={to}>
                <NavLink to={to} className={({ isActive }) => (isActive ? 'active' : undefined)}>
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </header>
      <main>
        {/* ルート単位のエラー境界。ページ描画のクラッシュを封じ込め、
            location.pathname を key にして遷移で回復させる。 */}
        <ErrorBoundary key={location.pathname} label="ページの描画">
          <Outlet />
        </ErrorBoundary>
      </main>
      <footer className="site-footer">
        <p>
          © 環付サクラ空間 ・ <Link to="/licenses">フォントライセンス</Link>
        </p>
      </footer>
    </div>
  );
}
